import * as React from 'react';
import { Text, View ,StyleSheet, TextInput ,TouchableOpacity ,useState} from 'react-native';
import { Ionicons } from '@expo/vector-icons'; 
import Swal from 'sweetalert2'

export default function validationsms({route,navigation}) {
    const [senha,setSenha] = React.useState('');
    const [cod,setCode] = React.useState('');
   //const register


  const ativation=(id,cod)=>{

    var validatinoApi ='https://emprestimoimperion.com/composer/controller/api/indexvalidationcode.php';
    var headers={
     'Accept':'application/json',
     'Content-Type':'application.json',
     'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
     'Access-Control-Allow-Origin':'*',
     'crossDomain': 'true',
     'Host': 'https://emprestimoimperion.com/composer/controller/api/indexvalidationcode.php',
     'Origin': 'https://emprestimoimperion.com',
     'credentials': 'same-origin',
     'Access-Control-Allow-Credentials': 'true'
     
      };
     /*'crossDomain': 'true',*/
     var Data={
      id:id,
      cod:cod
      };
  
      fetch(validatinoApi,
      {
      method:'POST',
      headers:headers,
      body:JSON.stringify(Data)
      }).then((response)=>response.json())
      .then((response)=>{
      if(response.statusCode==200){
      navigation.navigate('home')
      }else{
        Swal.fire({
          position: 'top',
          icon: 'error',
          title: 'Código Inválido',
          showConfirmButton: false,
          timer: 2000
        })
      } 
      }).catch((error)=>{
      alert(error);
      });
      
    }
  
  

  


  return (
<View style={{ flex: 1, alignItems: 'center' ,backgroundColor:'#01150E' }}>

<Ionicons name="logo-electron" size={80} color="white"  margin={40}/>

        <TextInput
        onChangeText={(cod) => setCode(cod)}
        style={{height: 40,
        margin: 12,
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderRightWidth:0,
        borderTopWidth: 0,
        borderColor:'white',
        outline: 'none',
        color:'white',
        placeholderTextColor:'white'}}
        onClick={()=>{/**/ }}
        placeholder="CODIGO"
        />

      <TouchableOpacity onPress = {() => {/* do this */
      if(cod.length>0){
        ativation(route.params.id,cod);
        
      }}}>
    <View style = {{backgroundColor: 'white', alignItems: 'center', 
                    justifyContent: 'center' ,borderRadius: 10,width:110 }}
           >
        <Text style = {{ color: '#01150E', padding:10}}>Entrar</Text>
          </View>
</TouchableOpacity>

<View style={{marginTop:20}}>
<a href='https://api.​whatsapp.com/send?phone=5554999471825&text=Preciso de ajuda'><Text style={styles.paragraph}>Estou tendo problemas</Text></a>

</View>

</View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: 16,
    marginVertical: 32,
  },
  section: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  paragraph: {
    fontSize: 15,
    color:'white'
  },
  checkbox: {
    margin: 8,
  },
});